var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1771 6.96805C1.1771 6.96805 9.6688 3.45571 12.6139 2.21897C13.7429 1.72428 17.5715 0.141253 17.5715 0.141253C17.5715 0.141253 19.3385 -0.55132 19.1913 1.13064C19.1422 1.82322 18.7495 4.24722 18.3568 6.86911C17.7678 10.5793 17.1297 14.6358 17.1297 14.6358C17.1297 14.6358 17.0315 15.7736 16.1971 15.9715C15.3627 16.1694 13.9883 15.2789 13.7429 15.0811C13.5465 14.9326 10.0615 12.7065 8.78527 11.6182C8.44168 11.3214 8.049 10.7277 8.83436 10.0352C10.6014 8.40266 12.7121 6.37441 13.9883 5.08821C14.5773 4.49457 15.1663 3.10942 12.7121 4.79139C9.22704 7.2154 5.79109 9.49099 5.79109 9.49099C5.79109 9.49099 5.00573 9.98569 3.53318 9.54046C2.06063 9.09524 0.342659 8.5016 0.342659 8.5016C0.342659 8.5016 -0.83538 7.75956 1.1771 6.96805Z",
    fill: "#7E7A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.6f3848d1.svg";
export { ForwardRef as ReactComponent };